/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */

import { Component, Input } from "@angular/core";
import { TakuInputCtrlBase } from "../TakuInputCtrlBase";

@Component({
  selector: "taku-calendar-datetime",
  templateUrl: "./taku-calendar-datetime.component.html",
  styleUrls: ["./taku-calendar-datetime.component.scss"],
})
export class TakuCalendarDatetimeComponent extends TakuInputCtrlBase {
  @Input() minDate?: string | Date = null;
  @Input() maxDate?: string | Date = null;
  @Input() appendTo?: any;

  clear() {
    this.ctrlField.reset();
  }
}

/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */
